module.exports = __webpack_public_path__ + "media/images/board-woody-1cbbfe56.jpeg";